import { Loading } from '@/components/loading';
import { cn } from '@/lib/utils';
import { PropsWithChildren, useEffect, useState } from 'react';

type Props = PropsWithChildren & {
  isLoading: boolean;
  message: string;
};
export const LoadingOverlay = ({ isLoading, message, children }: Props) => {
  const [showLoading, setShowLoading] = useState<boolean>();

  useEffect(() => {
    if (isLoading !== undefined && !isLoading) {
      // Delay removal to let the fade-out animation complete (300ms matches the animation duration)
      const timer = setTimeout(() => setShowLoading(false), 300);
      return () => clearTimeout(timer);
    } else {
      setShowLoading(true);
    }
  }, [isLoading]);

  return (
    <>
      {showLoading && (
        <div
          className={cn(
            'absolute inset-0 flex flex-col items-center justify-center bg-neutral-200 z-50 transition-opacity duration-300 ease-in-out',
            isLoading ? 'opacity-100' : 'opacity-0'
          )}
        >
          <div className={cn('w-1/2 h-10 justify-center items-center mb-4')}>
            <Loading color="#666" />
          </div>
          <h1 className={cn('text-2xl font-bold mb-4 text-neutral-500')}>{message}</h1>
        </div>
      )}
      {!isLoading && (
        <div className={cn('transition-opacity duration-300 ease-in-out', isLoading ? 'opacity-0' : 'opacity-100')}>{children}</div>
      )}
    </>
  );
};
